module.exports = __webpack_public_path__ + "img/3.bcc85b5c.png";